// import React from "react";


// const TermsAndConditions = () => {
//   return (
//     <div className="terms-container">
//       <h1 className="terms-title">Terms & Conditions</h1>

//       <p className="terms-date">
//         <strong>Effective Date:</strong> 12th January 2026
//       </p>

//       <p>
//         By using the <strong>DigiDoc</strong> mobile app ("App"), you agree to the
//         following Terms and Conditions ("Terms"). Please read them carefully.
//       </p>

//       <section>
//         <h3>1. Use of Service</h3>
//         <p>
//           The App provides tools for booking healthcare appointments, managing
//           treatments, and storing health records. You agree to:
//         </p>
//         <ul>
//           <li>Provide accurate and complete information.</li>
//           <li>Use the app only for lawful and personal purposes.</li>
//           <li>Not misuse the app or attempt unauthorized access.</li>
//         </ul>
//       </section>

//       <section>
//         <h3>2. Medical Disclaimer</h3>
//         <p>
//           The App provides information and tools to assist your healthcare
//           journey but does not replace professional medical advice. Always
//           consult your doctor about medical concerns.
//         </p>
//       </section>

//       <section>
//         <h3>3. User Accounts</h3>
//         <p>
//           You are responsible for maintaining the confidentiality of your
//           account credentials. Notify us immediately of any unauthorized
//           access.
//         </p>
//       </section>

//       <section>
//         <h3>4. Intellectual Property</h3>
//         <p>
//           All app content, design, logos, and software are owned by DigiDoc and
//           protected under intellectual property laws. Do not copy, modify, or
//           distribute without permission.
//         </p>
//       </section>

//       <section>
//         <h3>5. Limitation of Liability</h3>
//         <ul>
//           <li>Medical outcomes or decisions made using the app.</li>
//           <li>Errors, interruptions, or delays in the app.</li>
//           <li>Third-party content or services.</li>
//         </ul>
//       </section>

//       <section>
//         <h3>6. Termination</h3>
//         <p>
//           We may suspend or terminate your account if you violate these Terms or
//           misuse the service.
//         </p>
//       </section>

//       <section>
//         <h3>7. Governing Law</h3>
//         <p>
//           These Terms are governed by the laws of Chennai, Tamil Nadu, India.
//           Any disputes will be resolved under the exclusive jurisdiction of the
//           courts in Chennai, Tamil Nadu, India.
//         </p>
//       </section>

//       <section>
//         <h3>8. Changes to Terms</h3>
//         <p>
//           We may update these Terms periodically. We will notify you of
//           significant changes via the app or email.
//         </p>
//       </section>

//       <section>
//         <h3>9. Contact Us</h3>
//         <p>
//           <strong>Email:</strong> support@digidoc.co.in <br />
//           <strong>Address:</strong> S2, 21, Srinivasa Nagar, Kandanchavadi,
//           Perungudi, Chennai, Tamil Nadu 600096.
//         </p>
//       </section>
//     </div>
//   );
// };

// export default TermsAndConditions;
import React, { useEffect } from "react";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.container} className="background-clr">
      <h1 style={styles.title}>Terms &amp; Conditions</h1>

      <p style={styles.date}>
        <strong>Effective Date:</strong> 12th January 2026
      </p>

      <p>
        These Terms &amp; Conditions ("Terms") govern your access to and use of
        <strong> DigiDoc</strong>, a digital healthcare platform owned,
        operated, and managed by{" "}
        <strong>Digitivity Solutions Private Limited</strong> ("Digitivity
        Solutions", "Company", "we", "our", or "us").
      </p>

      <p>
        By downloading, accessing, registering for, or using the DigiDoc mobile
        application, website, or related services (collectively, the
        "Services"), you agree to be bound by these Terms. If you do not agree
        with these Terms, you should discontinue use of the Services.
      </p>

      <Section title="1. Use of the Services">
        <p>
          DigiDoc provides digital healthcare services including, but not
          limited to:
        </p>

        <ul>
          <li>Booking appointments with healthcare providers.</li>
          <li>Managing prescriptions and medication reminders.</li>
          <li>Maintaining personal health records.</li>
          <li>Accessing healthcare-related information and services.</li>
          <li>Communicating with authorized healthcare professionals.</li>
        </ul>

        <p>By using DigiDoc, you agree to:</p>

        <ul>
          <li>Provide accurate, complete, and up-to-date information.</li>
          <li>Maintain the confidentiality of your account credentials.</li>
          <li>Use the Services only for lawful and personal purposes.</li>
          <li>Comply with all applicable laws and regulations.</li>
          <li>
            Refrain from attempting unauthorized access to any part of the
            Services or related systems.
          </li>
        </ul>
      </Section>

      <Section title="2. Medical Disclaimer">
        <p>
          DigiDoc is a technology platform designed to facilitate healthcare
          management and communication. Digitivity Solutions Private Limited
          does not provide medical advice, diagnosis, or treatment.
        </p>

        <p>
          Information available through DigiDoc is intended solely to support
          your healthcare journey and should not be considered a substitute for
          professional medical advice. Always consult a qualified healthcare
          professional regarding any medical condition or treatment.
        </p>

        <p>
          In the event of a medical emergency, contact your nearest emergency
          medical service immediately.
        </p>
      </Section>

      <Section title="3. User Accounts">
        <p>You are responsible for:</p>

        <ul>
          <li>Maintaining the confidentiality of your login credentials.</li>
          <li>All activities conducted through your account.</li>
          <li>
            Promptly notifying us of any unauthorized use or suspected security
            breach.
          </li>
        </ul>

        <p>
          Digitivity Solutions reserves the right to suspend or terminate
          accounts that violate these Terms or pose a security risk.
        </p>
      </Section>

      <Section title="4. Intellectual Property">
        <p>
          DigiDoc, including its software, user interface, trademarks, logos,
          graphics, content, databases, and underlying technology, is the
          exclusive property of Digitivity Solutions Private Limited or its
          licensors and is protected under applicable intellectual property
          laws.
        </p>

        <p>
          You may not copy, reproduce, modify, distribute, reverse engineer, or
          create derivative works from any part of the Services without prior
          written permission.
        </p>
      </Section>

      <Section title="5. Third-Party Services">
        <p>
          DigiDoc may integrate with third-party healthcare providers,
          laboratories, pharmacies, payment gateways, cloud service providers,
          analytics platforms, or communication services.
        </p>

        <p>
          Digitivity Solutions is not responsible for the availability,
          accuracy, policies, or performance of any third-party services. Your
          use of such services may also be subject to their respective terms and
          privacy policies.
        </p>
      </Section>

      <Section title="6. Limitation of Liability">
        <p>
          To the maximum extent permitted by applicable law, Digitivity
          Solutions Private Limited shall not be liable for:
        </p>

        <ul>
          <li>
            Medical decisions or treatment outcomes based on information
            available through DigiDoc.
          </li>
          <li>Delays, interruptions, or temporary unavailability of the Services.</li>
          <li>
            Loss of data caused by factors beyond our reasonable control.
          </li>
          <li>Errors or omissions in information provided by third parties.</li>
          <li>
            Any indirect, incidental, consequential, or special damages arising
            from the use or inability to use the Services.
          </li>
        </ul>
      </Section>

      <Section title="7. Suspension and Termination">
        <p>
          We reserve the right to suspend, restrict, or terminate your access
          to DigiDoc without prior notice if:
        </p>

        <ul>
          <li>You violate these Terms.</li>
          <li>You misuse the Services.</li>
          <li>
            Your activities compromise the security or integrity of the
            platform.
          </li>
          <li>We are required to do so under applicable law.</li>
        </ul>

        <p>
          Termination does not limit any legal rights or remedies available to
          Digitivity Solutions.
        </p>
      </Section>

      <Section title="8. Governing Law and Jurisdiction">
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of India.
        </p>

        <p>
          Any disputes arising out of or relating to these Terms or the Services
          shall be subject to the exclusive jurisdiction of the competent courts
          located in Chennai, Tamil Nadu, India.
        </p>
      </Section>

      <Section title="9. Changes to these Terms">
        <p>
          Digitivity Solutions Private Limited may revise these Terms from time
          to time.
        </p>

        <p>
          Updated versions will be made available through DigiDoc or other
          appropriate communication channels. Continued use of the Services
          after the revised Terms become effective constitutes your acceptance
          of the updated Terms.
        </p>
      </Section>

      <Section title="10. Contact Us">
        <p>
          If you have any questions regarding these Terms &amp; Conditions,
          please contact:
        </p>

        <p>
          <strong>Digitivity Solutions Private Limited</strong>
          <br />
          <strong>Product:</strong> DigiDoc
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:support@digidoc.co.in">
            support@digidoc.co.in
          </a>
          <br />
          <strong>Registered Address:</strong>
          <br />
          S2, 21, Srinivasa Nagar,
          <br />
          Kandanchavadi, Perungudi,
          <br />
          Chennai, Tamil Nadu – 600096,
          <br />
          India.
        </p>
      </Section>
    </div>
  );
};

/* Reusable Section Component */
const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h2 style={styles.heading}>{title}</h2>
    {children}
  </div>
);

/* Styling */
const styles = {
  container: {
    margin: "40px auto",
    padding: "20px 40px",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.7,
    color: "#333",
  },
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#4da9ff",
  },
  date: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#555",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    marginBottom: "10px",
    color: "#4da9ff",
  },
};

export default TermsAndConditions;